import { Splide } from "@splidejs/splide";
import "@splidejs/splide/css";
import { fadeInChildrenRTL } from "./animations";

let heroSlider: Splide;

document.addEventListener("DOMContentLoaded", () => {
  heroSlider = (window as any).heroCarousel;

  if (!heroSlider) return;

  heroSlider.options.rewind = true;

  const firstSlide = heroSlider.Components.Slides.getAt(heroSlider.index);

  fadeInChildrenRTL(firstSlide?.slide.firstElementChild);

  heroSlider.on("active", ({ slide }) => {
    const child = slide.firstElementChild;

    fadeInChildrenRTL(child);
  });
});

const contentSliderEl = document.querySelector(
  ".hero-content-slider"
) as HTMLElement;
const videoSliderEl = document.querySelector(
  ".hero-video-slider"
) as HTMLElement;

if (contentSliderEl && videoSliderEl) {
  const contentSlider = new Splide(contentSliderEl, {
    type: "fade",
    pagination: false,
    autoplay: true,
    interval: 8000,
    pauseOnFocus: false,
    pauseOnHover: false,
    drag: false,
    arrows: false,
    rewind: true,
  });

  contentSlider.on("active", ({ slide }) => {
    const child = slide.firstElementChild;

    fadeInChildrenRTL(child);
  });

  const videoSlider = new Splide(videoSliderEl, {
    type: "fade",
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    pagination: false,
  });

  contentSlider.sync(videoSlider);
  contentSlider.mount();
  videoSlider.mount();
}
